<template>
  <div class="bid-file-preview">
    <!-- 标书预览余额 -->
    <bid-file-preview-balance class="m-b-16" />
    <!-- 标书预览历史记录/项目列表 -->
    <bid-file-preview-history />
  </div>
</template>

<script>
import BidFilePreviewBalance from '@/components/PersonalCenter/BidFilePreviewBalance'
import BidFilePreviewHistory from '@/components/PersonalCenter/BidFilePreviewHistory'

export default {
  name: 'BidFilePreview',

  components: {
    BidFilePreviewBalance,
    BidFilePreviewHistory
  }
}
</script>

<style lang="scss" scoped>
.bid-file-preview {
  width: 100%;
}
</style>
